export enum InsuranceSubscriptionSnapshotType {
  IMPORT = 'IMPORT',
  SNAPSHOT = 'SNAPSHOT'
}
